// endpoint authentication
export const AUTH_ENDPOINTS = {
  LOGIN: "/api/v1/businesses/auth/sign-in",
  VERIFYOTP: "/api/v1/businesses/auth/verify-otp-signup",
  RESENDOTP: "/api/v1/businesses/auth/resend-otp-signup",
  LOGOUT: "/api/v1/businesses/auth/logout",
  REGISTER: "/api/v1/businesses/auth/signup",
};

// endpoint other
export const ENDPOINTS = {
  //Search company
  SEARCH_COMPANY: "/api/v1/businesses/extract_info",
  FIRT_UPDATE_INFO: "/api/v1/businesses/first-update-info",

  // Profile
  GET_USER_INFO: "/api/v1/businesses/auth/me",
  UPDATE_USER_INFO: "/api/v1/businesses/auth/update-profile",
  UPDATE_AVATAR: "/api/v1/businesses/update-avatar",
  //Quest
  QUEST_LIST: "/api/v1/businesses/quests/list",
  GET_QUEST_DETAILS: "/api/v1/businesses/quests/detail",
  GET_QUEST_QUESTION_LIST: "/api/v1/businesses/quests/questions",
  ACTION_EDIT_QUEST_DETAILS: "/api/v1/businesses/quests/action",
  TAKE_QUEST: "/api/v1/consumers/quests/questions",
  POST_ANSWERS: "/api/v1/consumers/quests/answers",
  POST_TAKE_QUEST_PRACTICE: "/api/v1/consumers/quests/practice",
  POST_QUEST_RECEIPT: "/api/v1/consumers/quests/participant/receipt",
  POST_QUEST_REVIEWING: "/api/v1/consumers/quests/complete",

  // Ondemand

  GET_OBJECTIVES: "/api/v1/businesses/objectives",
  GET_SEGMENTATIONS: "/api/v1/businesses/segmentations",
  POST_GEN_AI_OBJECTIVES: "/api/v1/businesses/quests/ai/gen-objective",
  POST_ON_DEMAND: "/api/v1/businesses/quests/on_demand",
  GET_LOCATION_BUSINESS: "/api/v1/businesses/locations",
  GET_LOCATION_LAT_LONG: "/api/v1/businesses/get-coordinates",
  POST_IMAGE_UPLOAD: "/api/v1/upload_file",
  AI_GEN_INFO: "/api/v1/businesses/quests/ai/gen-info",
  AI_GEN_QUESTION: "/api/v1/businesses/quests/ai/generate-objective-questions",

  CALCULATOR_INCENTIVE: "/api/v1/businesses/calculate-incentive",
  CALCULATOR_TOKEN_XP: "/api/v1/businesses/quests/incentive",

  CALCULATOR_MYSTERY_SHOPPER: "/api/v1/businesses/quests/mysteryshopper",
  //Quest Result
  POST_QUEST_TASK_RESULT: "/api/v1/businesses/quests/quest-results",

  //Quest QR Code
  // GEN_QR_CODE: "/api/v1/businesses/gen_quest_qr_code",
  GEN_QR_CODE: "/api/v1/businesses/gen_quest_qr_code_by_location",

  //Performance
  GET_PERFORMANCE: "/api/v1/businesses/performance",

  //Location
  POST_FIND_NEW_LOCATION: "/api/v1/businesses/get-address",
  GET_PERFORMANCE_DETAILS: "/api/v1/businesses/performance/detail",

  //Top up
  POST_TOP_UP: "/api/v1/businesses/topups/createtopup",
  GET_TOP_UP_HISTORY: "/api/v1/businesses/topups/historytopup",
};
